<!-- Visualização normal (sem comparar versões) -->
<ng-container *ngIf="!comparingVersions">
    <div class="col-12" *ngIf="loading">
        <div class="row">
            <div class="col-12">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!loading">
        <div class="col-12">
            <div class="dash-details-card card-padding-top">
                <app-empty-content [isVisible]="data.length === 0"
                    title="Nenhum grupo encontrado"
                    description="Não foi encontrado nenhum grupo nesse cadastro"
                    icon="/assets/images/forgot-password-icon2.png">
                </app-empty-content>

                <div class="table-scroll-container" *ngIf="data.length > 0">
                    <table class="table groups-table">
                        <thead>
                            <tr>
                                <th>Grupos</th>
                                <th>Tipo do grupo</th>
                                <th>{{ renderLabel() }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of data">
                                <td>{{ item.name }}</td>
                                <td>{{ item.representative_type_display ||
                                    item.representative_type }}</td>
                                <td>
                                    {{ formatGroupIntegrants(item.members, null)
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <ng-container *ngIf="powerGroupData.length > 0">
                <div class="dash-details-card card-padding-top mt-4">
                    <div class="table-scroll-container">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th style="min-width: 350px;">Poderes</th>
                                    <th class="text-center">Assinaturas
                                        obrigatórias</th>
                                    <th class="text-center">Assinaturas
                                        necessárias</th>
                                    <th>Grupo principal</th>
                                    <th>Grupo secundário</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of powerGroupData">
                                    <td>{{ formatPower(item.power_type) }}</td>
                                    <td class="text-center">{{
                                        item.required_signs_quantity }}</td>
                                    <td class="text-center">{{
                                        item.necessary_signs_quantity }}</td>
                                    <td>{{ getMainGroupName(item, null) }}</td>
                                    <td>{{ formatGroup(item.secondary_group &&
                                        item.secondary_group.length > 0 ? { id:
                                        item.secondary_group } : null, false,
                                        null) }}</td>
                                    <td class="text-center" *ngIf="canView">
                                        <svg-icon
                                            src="assets/images/icon-eye.svg"
                                            style="cursor: pointer;"
                                            (click)="openModalById(item.id)"></svg-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </ng-container>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>
</ng-container>

<!-- Visualização com comparação de versões -->
<ng-container *ngIf="comparingVersions">
    <div class="row">
        <!-- Lado esquerdo - Versão Principal -->
        <div class="col-6">
            <ng-container *ngIf="approvalService.approvalData.mainVersion && mainLoading">
                <div class="row">
                    <div class="col-12">
                        <ngx-skeleton-loader [theme]="{
                                    height: '244px',
                                    margin:'0 0 24px'
                                }">
                        </ngx-skeleton-loader>
                    </div>
                    <div class="col-12">
                        <ngx-skeleton-loader [theme]="{
                                    height: '244px',
                                    margin:'0 0 24px'
                                }">
                        </ngx-skeleton-loader>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="approvalService.approvalData.mainVersion && !mainLoading">
                <div class="dash-details-card card-padding-top">
                    <app-empty-content [isVisible]="mainData.length === 0"
                        title="Nenhum grupo encontrado"
                        description="Não foi encontrado nenhum grupo nesse cadastro"
                        icon="/assets/images/forgot-password-icon2.png">
                    </app-empty-content>

                    <div class="table-scroll-container"
                        *ngIf="mainData.length > 0">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Grupos</th>
                                    <th>Tipo do grupo</th>
                                    <th>{{ renderLabel() }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of mainData">
                                    <td>
                                        <div
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span>{{ item.name }}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <span>
                                            {{ item.representative_type_display
                                            ||
                                            item.representative_type }}
                                        </span>
                                    </td>
                                    <td>
                                        <div class="dash-details-card-item-title"
                                            style="white-space: pre-line; word-wrap: normal; margin: 0; line-height: 1.5;">
                                            {{
                                            formatGroupIntegrants(item.members,
                                            'main') }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="dash-details-card card-padding-top mt-4"
                    *ngIf="mainPowerGroupData.length > 0">
                    <div class="table-scroll-container">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Poderes</th>
                                    <th class="text-center">Assinaturas
                                        obrigatórias</th>
                                    <th class="text-center">Assinaturas
                                        necessárias</th>
                                    <th>Grupo principal</th>
                                    <th>Grupo secundário</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of mainPowerGroupData">
                                    <td>
                                        <div
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span>{{ formatPower(item.power_type)
                                                }}</span>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <span>{{ item.required_signs_quantity
                                            }}</span>
                                    </td>
                                    <td class="text-center">
                                        <span>{{ item.necessary_signs_quantity
                                            }}</span>
                                    </td>
                                    <td>
                                        <span>{{ getMainGroupName(item, 'main')
                                            }}</span>
                                    </td>
                                    <td>
                                        <span>{{ formatGroup(item.secondary_group
                                            &&
                                            item.secondary_group.length > 0 ? {
                                            id:
                                            item.secondary_group } : null,
                                            false,
                                            null) }}</span>
                                    </td>
                                    <td class="text-center" *ngIf="canView">
                                        <svg-icon
                                            src="assets/images/icon-eye.svg"
                                            style="cursor: pointer;"
                                            (click)="openModalById(item.id)"></svg-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!approvalService.approvalData.mainVersion">
                <app-select-version-comparison></app-select-version-comparison>
            </ng-container>
        </div>

        <!-- Lado direito - Versão Comparando -->
        <div class="col-6">
            <ng-container *ngIf="approvalService.approvalData.comparingVersion">
                <!-- Dois blocões de skeleton, um para cada card -->
                <ng-container *ngIf="comparingDataLoading">
                    <div class="row">
                        <div class="col-12">
                            <ngx-skeleton-loader [theme]="{
                                        height: '244px',
                                        margin:'0 0 24px'
                                    }">
                            </ngx-skeleton-loader>
                        </div>
                        <div class="col-12">
                            <ngx-skeleton-loader [theme]="{
                                        height: '244px',
                                        margin:'0 0 24px'
                                    }">
                            </ngx-skeleton-loader>
                        </div>
                    </div>
                </ng-container>

                <div class="row" *ngIf="!comparingDataLoading">
                    <div class="col-12">
                        <div class="dash-details-card card-padding-top">
                            <app-empty-content
                                [isVisible]="comparingData.length === 0"
                                title="Nenhum grupo encontrado"
                                description="Não foi encontrado nenhum grupo nesse cadastro"
                                icon="/assets/images/forgot-password-icon2.png">
                            </app-empty-content>

                            <div class="table-scroll-container"
                                *ngIf="comparingData.length > 0">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Grupos</th>
                                            <th>Tipo do grupo</th>
                                            <th>{{ renderLabel() }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of comparingData"
                                            [class]="item.compareClass">
                                            <td>
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <img
                                                        *ngIf="item.compareClass === 'row-compare-added'"
                                                        src="/assets/images/carbon-checkmark.svg"
                                                        class="comparison-icon" alt="adicionado" />
                                                    <img
                                                        *ngIf="item.compareClass === 'row-compare-removed'"
                                                        src="/assets/images/carbon-error-warning.svg"
                                                        class="comparison-icon" alt="removido" />
                                                    <img
                                                        *ngIf="item.compareClass === 'row-compare-modified' && item.changedFields?.name"
                                                        src="/assets/images/carbon-warning.svg"
                                                        class="comparison-icon" alt="alterado" />
                                                    <span
                                                        [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">{{
                                                        item.name }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <img
                                                        *ngIf="item.compareClass === 'row-compare-modified' && item.changedFields?.representative_type"
                                                        src="/assets/images/carbon-warning.svg"
                                                        class="comparison-icon" alt="alterado" />
                                                    <span
                                                        [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">{{
                                                        item.representative_type_display
                                                        ||
                                                        item.representative_type
                                                        }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <img
                                                        *ngIf="item.compareClass === 'row-compare-modified' && item.changedFields?.members"
                                                        src="/assets/images/carbon-warning.svg"
                                                        class="comparison-icon" alt="alterado" />
                                                    <div class="dash-details-card-item-title"
                                                        [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'"
                                                        style="white-space: pre-line; word-wrap: normal; margin: 0; line-height: 1.5;">
                                                        {{
                                                        formatGroupIntegrants(item.members,
                                                        'comparing') }}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="dash-details-card card-padding-top mt-4"
                            *ngIf="comparingPowerGroupData.length > 0">
                            <div class="table-scroll-container">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th style="min-width: 350px;">
                                                Poderes</th>
                                            <th class="text-center">Assinaturas
                                                obrigatórias</th>
                                            <th class="text-center">Assinaturas
                                                necessárias</th>
                                            <th>Grupo principal</th>
                                            <th>Grupo secundário</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of comparingPowerGroupData"
                                            [class]="item.compareClass">
                                            <td>
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <img
                                                        *ngIf="item.compareClass === 'row-compare-added'"
                                                        src="/assets/images/carbon-checkmark.svg"
                                                        class="comparison-icon" alt="adicionado" />
                                                    <img
                                                        *ngIf="item.compareClass === 'row-compare-removed'"
                                                        src="/assets/images/carbon-error-warning.svg"
                                                        class="comparison-icon" alt="removido" />
                                                    <img
                                                        *ngIf="item.compareClass === 'row-compare-modified' && item.changedFields?.power_type"
                                                        src="/assets/images/carbon-warning.svg"
                                                        class="comparison-icon" alt="alterado" />
                                                    <span
                                                        [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">{{
                                                        formatPower(item.power_type)
                                                        }}</span>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div
                                                    style="display: flex; align-items: center; justify-content: center; gap: 6px;">
                                                    <img
                                                        *ngIf="item.compareClass === 'row-compare-modified' && item.changedFields?.required_signs_quantity"
                                                        src="/assets/images/carbon-warning.svg"
                                                        class="comparison-icon" alt="alterado" />
                                                    <span
                                                        [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">{{
                                                        item.required_signs_quantity
                                                        }}</span>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div
                                                    style="display: flex; align-items: center; justify-content: center; gap: 6px;">
                                                    <img
                                                        *ngIf="item.compareClass === 'row-compare-modified' && item.changedFields?.necessary_signs_quantity"
                                                        src="/assets/images/carbon-warning.svg"
                                                        class="comparison-icon" alt="alterado" />
                                                    <span
                                                        [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">{{
                                                        item.necessary_signs_quantity
                                                        }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <img
                                                        *ngIf="item.compareClass === 'row-compare-modified' && item.changedFields?.main_group"
                                                        src="/assets/images/carbon-warning.svg"
                                                        class="comparison-icon" alt="alterado" />
                                                    <span
                                                        [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">{{
                                                        formatGroup(item.main_group
                                                        ? [{ id:
                                                        item.main_group[0] }] :
                                                        [], true, null)
                                                        }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <img
                                                        *ngIf="item.compareClass === 'row-compare-modified' && item.changedFields?.secondary_group"
                                                        src="/assets/images/carbon-warning.svg"
                                                        class="comparison-icon" alt="alterado" />
                                                    <span
                                                        [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">{{
                                                        formatGroup(item.secondary_group
                                                        &&
                                                        item.secondary_group.length
                                                        > 0 ? { id:
                                                        item.secondary_group } :
                                                        null, false, null)
                                                        }}</span>
                                                </div>
                                            </td>
                                            <td class="text-center"
                                                *ngIf="canView">
                                                <svg-icon
                                                    src="assets/images/icon-eye.svg"
                                                    style="cursor: pointer;"
                                                    (click)="openModalById(item.id)"></svg-icon>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>
            </ng-container>
            <ng-container
                *ngIf="!approvalService.approvalData.comparingVersion">
                <app-select-version-comparison></app-select-version-comparison>
            </ng-container>
        </div>
    </div>
</ng-container>

<app-side-modal [active]="powerGroupDetails" title="Detalhes do grupo de poder"
    (onClose)="closeModal()" paddingBottom="30">
    <div class="container">
        <div class="row" *ngIf="selectedPowerGroup">
            <div class="col-12 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    Tipo de poder
                </span>

                <span class="dash-details-card-item-title">
                    {{formatPower(selectedPowerGroup.power_type)}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 d-flex flex-column"
                *ngIf="selectedPowerGroup.default_power_type && selectedPowerGroup.default_power_type.length > 0">
                <span class="dash-details-card-item-subtitle">
                    Poder padrão
                </span>

                <span class="dash-details-card-item-title">
                    {{formatPower(selectedPowerGroup.default_power_type)}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 col-md-6 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    Grupo principal
                </span>

                <span class="dash-details-card-item-title">
                    {{formatGroup([selectedPowerGroup.main_group], true,
                    selectedPowerGroupVersionType)}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 col-md-6 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    Grupo secundário
                </span>

                <span class="dash-details-card-item-title">
                    {{formatGroup(selectedPowerGroup.secondary_group, false,
                    selectedPowerGroupVersionType)}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    Qt. mín. de assinaturas necessárias
                </span>

                <span class="dash-details-card-item-title">
                    {{selectedPowerGroup.necessary_signs_quantity}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    Assinantes necessários
                </span>

                <div class="dash-details-card-item-title"
                    style="white-space: pre-line; line-height: 1.5;">
                    {{formatPowerIntegrants(selectedPowerGroup.necessary_signs,
                    selectedPowerGroupVersionType)}}</div>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    Qt. mín. de assinaturas obrigatórias
                </span>

                <span class="dash-details-card-item-title">
                    {{selectedPowerGroup.required_signs_quantity}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>


            <div class="col-12 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    Assinantes obrigatórios
                </span>

                <div class="dash-details-card-item-title"
                    style="white-space: pre-line; line-height: 1.5;">
                    {{formatPowerIntegrants(selectedPowerGroup.required_signs,
                    selectedPowerGroupVersionType)}}</div>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 col-md-6 d-flex flex-column"
                *ngIf="selectedPowerGroup && selectedPowerGroup.min_sign_amount">
                <span class="dash-details-card-item-subtitle">
                    Valor min. para assinatura
                </span>

                <span class="dash-details-card-item-title">
                    {{selectedPowerGroup.min_sign_amount | currency:'BRL'}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 col-md-6 d-flex flex-column"
                *ngIf="selectedPowerGroup && selectedPowerGroup.min_sign_amount">
                <span class="dash-details-card-item-subtitle">
                    Valor máx. para assinatura
                </span>

                <span class="dash-details-card-item-title">
                    {{formatMaxValue(selectedPowerGroup)}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 d-flex flex-column"
                *ngIf="selectedPowerGroup && selectedPowerGroup.description">
                <span class="dash-details-card-item-subtitle">
                    Descrição dos poderes
                </span>

                <span class="dash-details-card-item-title">
                    {{selectedPowerGroup.description}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>
        </div>
    </div>
</app-side-modal>